import { useTranslation } from 'react-i18next';
import { useFeature } from '../../../hooks/useAccess';
import Header from './Header';
import AddForm from '../AddForm';
import ContactInfo from './ContactInfo';
import PortfolioSummary from './PortfolioSummary';
import CommissionHistory from './CommissionHistory';
import AssociatedClients from './AssociatedClients';
import AppLayout from '../../../components/AppLayout';

const SelectedBroker = ({ associatedClients, selectedBroker, setSelectedBroker, showAddForm, setShowAddForm, newBroker, setNewBroker, submitting, handleAddBroker, handleDeleteBroker }) => {
  const { t } = useTranslation();
  // Commission History is gated on the tenant's own feature flag, read through
  // the same useFeature hook that gates the nav and the routes.
  //
  // Module-level gating already removed Commissions from the sidebar, but this
  // detail page kept rendering the section — and on a tenant with commissions
  // off it can only ever be empty, so it advertised a module the customer does
  // not have and then showed nothing in it. Backend denial is not enough: an
  // absent feature must leave no section, no button and no empty card.
  const commissionsEnabled = useFeature('commissions');
  const b = selectedBroker;
  // CommissionHistory now fetches its own data from /commissions/records so
  // it reflects the calculated engine's state rather than the broker's
  // embedded (legacy) commissionHistory array.
  const clients = Array.isArray(b.associatedClients) && b.associatedClients.length > 0
    ? b.associatedClients
    : (associatedClients || []);
  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Header b={b} setSelectedBroker={setSelectedBroker} setShowAddForm={setShowAddForm} setNewBroker={setNewBroker} onDelete={handleDeleteBroker} />

        <div style={{ flex: 1, overflowY: 'auto', padding: '24px 32px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 24 }}>
            <ContactInfo b={b} />
            <PortfolioSummary b={b} />
          </div>

          {commissionsEnabled && <CommissionHistory b={b} />}
          <AssociatedClients associatedClients={clients} />
        </div>
      </div>
      {showAddForm && (
        <AddForm
          title={t('screens.brokers.editBroker', { defaultValue: 'Edit Broker' })}
          btnText={t('screens.brokers.editBroker', { defaultValue: 'Edit Broker' })}
          setShowAddForm={setShowAddForm}
          newBroker={newBroker}
          setNewBroker={setNewBroker}
          submitting={submitting}
          handleAddBroker={handleAddBroker}
        />
      )}
    </AppLayout>
  );
};

export default SelectedBroker;
